import React from "react";
import { Helmet } from "react-helmet-async";

const BASE = "https://mypushapp.it";

export const Seo = ({ title, description, path = "/", ogTitle, ogDescription, jsonLd }) => {
  const url = `${BASE}${path}`;
  const ogt = ogTitle || title;
  const ogd = ogDescription || description;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={ogt} />
      <meta property="og:description" content={ogd} />
      <meta property="og:url" content={url} />

      <meta name="twitter:title" content={ogt} />
      <meta name="twitter:description" content={ogd} />

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};
